<template>
    <div class="bg-light" style="height: 100vh">
        <div class="container h-100">
            <div class="d-flex justify-content-center flex-column h-100">
                <div class="mx-4 text-center">
                    <img src="/client/images/logo-owl.png" class="img-fluid" alt="logo" />
                </div>
                <div class="text-center p-5 m-4">
                    <h2>{{ titles[status] }}</h2>
                    <div class="py-3">{{ messages[status] }}</div>

                    <div class="pt-3">
                        <a href="/" class="btn btn-primary btn-lg">
                            {{ status == '503' ? 'Try again' : 'Take me home' }}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                status: this.$route.params.status,
                titles: {
                    '403': '403 Access forbidden',
                    '404': '404 Not found',
                    '419': '419 Page Expired',
                    '500': '500 Server error',
                    '503': '503 Under maintenance'
                },
                messages: {
                    '403': "You are trying to access a page for which you don't have privileges.",
                    '404': 'The link is broken or the page has moved, we couldn’t complete your request',
                    '419':
                        'It looks like the page you are trying to access has expired. Please make sure you are logged in the application and try again.',
                    '500':
                        'We are very sorry, but were unable to complete your request. We took a note about this error and we will provide a fix as soon as possible.',
                    '503':
                        "Sorry for the inconvenience but we're performing some maintenance at the moment and we will be back online shortly. Thanks for your patience."
                }
            };
        },
        beforeMount() {
            if (!Object.keys(this.titles).includes(this.status)) {
                this.status = 404;

                this.$router.replace('/error/404');
            }

            window.document.title = `Error - ${this.status} | ${window.app.title}`;
        }
    };
</script>
